// extracted by mini-css-extract-plugin
var _1 = "HeroBanner_wrapperBanner__cog9t";
export { _1 as "wrapperBanner" }
